const buildRouteTreeOrder = (routes) => {
    const routeOrder = new Map();
    let index = 0;
    const addRoutes = (children) => {
        children.forEach(route => {
            routeOrder.set(route.VueRouterName, index++);
            addRoutes(route.Children || []);
        });
    };
    addRoutes(routes);
    return routeOrder;
};
const sortRoutesByTreeOrder = (routes) => {
    return [...routes].sort((a, b) => {
        const aOrder = a.meta?.routeTreeOrder;
        const bOrder = b.meta?.routeTreeOrder;
        if (typeof aOrder !== "number")
            return typeof bOrder !== "number" ? 0 : 1;
        if (typeof bOrder !== "number")
            return -1;
        return aOrder - bOrder;
    });
};
export { buildRouteTreeOrder, sortRoutesByTreeOrder };
